import lod_ from "lodash";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectKnowledgeBaseConfig } from "redux-react/reducers/knowledgeBaseReducer";
import { selectCurrentProfile } from "redux-react/reducers/profileReducer";
import { selectUser } from "redux-react/reducers/userReducers";

const SHADOW_HOST_ID = "faibrik-chat-shadow-host";
const CHATBOT_SCRIPT_ID = "faibrik-chatbot-script";

const useChatbotScript = ({ apiKey, scriptUrl, metadatas = {} }) => {
	const knowledgeBaseConfig = useSelector(selectKnowledgeBaseConfig);
	const user = useSelector(selectUser);
	const profile = useSelector(selectCurrentProfile);

	const testRuntimeCode = knowledgeBaseConfig?.testRuntimeCode;

	useEffect(() => {
		// Cleanup on unmount or profile change
		const cleanup = () => {
			const scriptToRemove = document.getElementById(CHATBOT_SCRIPT_ID);
			const shadowHostToRemove = document.getElementById(SHADOW_HOST_ID);

			if (shadowHostToRemove) {
				shadowHostToRemove.remove();
			}
			if (scriptToRemove) {
				scriptToRemove.remove();
			}
			// Destroy chat instance if available
			if (window.fAIbrikChat?.destroy) {
				window.fAIbrikChat?.destroy();
			}
		};

		cleanup();

		if (
			lod_.isNil(profile) ||
			lod_.isEmpty(profile) ||
			lod_.isNil(scriptUrl) // ||
			// lod_.isNil(apiKey)
		) {
			cleanup();
			return undefined;
		}

		if (lod_.isEmpty(testRuntimeCode)) {
			cleanup();
			return undefined;
		}

		// Create and inject the chatbot script
		const script = document.createElement("script");
		script.id = CHATBOT_SCRIPT_ID;
		script.src = scriptUrl;
		script.async = true;

		// Initialize fAIbrikChat once the script is loaded
		script.onload = () => {
			if (window.fAIbrikChat) {
				window.fAIbrikChat.init({
					communication: {
						apiKey,
						clientData: {
							runtimeCode: testRuntimeCode,
							userID: user.userID,
							assistantID: profile.assistantID,
							application: process.env.REACT_APP_APPNAME,
							metadatas: metadatas || {}
						}
					}
				});
			}
		};

		document.body.appendChild(script);

		return cleanup;
	}, [
		profile,
		user,
		apiKey,
		scriptUrl,
		JSON.stringify(metadatas),
		knowledgeBaseConfig,
		knowledgeBaseConfig?.testRuntimeCode
	]); // Re-run effect if profile, user, apiKey, scriptUrl or metadatas change
};

export default useChatbotScript;
